export const MONTH_NAMES = {
  nl: ["januari", "februari", "maart", "april", "mei", "juni", "juli",
       "augustus", "september", "oktober", "november", "december"],
  en: ["January", "February", "March", "April", "May", "June", "July",
       "August", "September", "October", "November", "December"],
};

export function ymToLabel(val, lang) {
  if (!val) return "";
  const m = /^(\d{4})-(\d{1,2})$/.exec(val);
  if (!m) return val;
  const names = MONTH_NAMES[lang] || MONTH_NAMES.nl;
  const mi = parseInt(m[2], 10);
  return mi >= 1 && mi <= 12 ? `${names[mi - 1]} ${m[1]}` : m[1];
}

export function formatPeriod(item, lang, presentWord) {
  const s = ymToLabel(item.start, lang);
  const e = item.current ? presentWord : ymToLabel(item.end, lang);
  if (s && e) return `${s} — ${e}`;
  return s || e || "";
}

export const newId = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID()
    : `id_${Date.now()}_${Math.random().toString(36).slice(2)}`;

export const newExperience = () => ({
  id: newId(), role: "", company: "", location: "",
  start: "", end: "", current: false, description: "",
});

export const newEducation = () => ({
  id: newId(), title: "", institution: "", year: "",
});

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/**
 * Extract the server-provided filename from a Content-Disposition
 * header. Falls back to the caller's default when the header is missing
 * or unparseable — keeps downloads working even if the browser or
 * proxy strips the header.
 */
export function filenameFromResponse(response, fallback) {
  const header = response?.headers?.["content-disposition"]
    || response?.headers?.["Content-Disposition"]
    || "";
  // RFC 5987 form first (filename*=UTF-8''...), then simple filename="...".
  const star = /filename\*=UTF-8''([^;\n]+)/i.exec(header);
  if (star && star[1]) {
    try { return decodeURIComponent(star[1].replace(/^"|"$/g, "")); } catch (_) { /* ignore */ }
  }
  const plain = /filename\s*=\s*"?([^";\n]+)"?/i.exec(header);
  if (plain && plain[1]) return plain[1].trim();
  return fallback;
}
